// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cat-title {
  color: red;
}

body {
  font-family: Arial, sans-serif;
}

.actions {
  display: flex;
  justify-content: center;
}

.actions button {
  margin-right: 50px;
}

.Authority {
  text-align: center;
  font-size: 1px;
}

.blue-text {
  color: #6699cc;
  font-weight: bold;
}

.file-container {
  border: 1px solid #d3d3d3;
  border-radius: 10px;
  margin: 2% 0%;
  background-color: #fff;
  max-width: 100%;
}

#empDetails {
  width: 350px;
  height: 35px;
}

#query {
  width: 250px;
  height: 35px;
}
.shift{
  margin-left: 10%;
}
.shift-left{
  margin-right: -28%;
}

.input-group input[type="text"] {
  margin-right: 30px;
}

.title h3{
  background-color: #6699cc;
  color: #ffffff;
  padding: 10px;
  text-align: left;
}

.auth-codes {
  text-align: center;
}

.doa-group {
  margin-bottom: 20px;
}

.doa-type {
  display: flex;
  flex-direction: column;
}

.type-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.type-name {
  flex: 1;
  margin-bottom: 10px;
}

.type-dollar {
  flex: 0 0 150px;
  text-align: right;
}

.doa-dollar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dollar-text {
  margin-left: auto;
  margin-right: 11%; 
}

.sub-cat-name {
  margin-bottom: 10px;
}

.invalid {
  border: 1px solid red;
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}

.bordered-container {
  border: 1px solid #d3d3d3; 
  padding: 20px;
  max-width: 100%;
  margin: 3% 0%;
  border-radius: 1px;
  padding-bottom: 1%;
}
.reduced-gap {
  margin-left: -8%;
}
.reduced-gap-go {
  margin-left: -13%;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/administrator/employees-doa-setup/employees-doa-setup.component.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".cat-title {\n  color: red;\n}\n\nbody {\n  font-family: Arial, sans-serif;\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n}\n\n.actions button {\n  margin-right: 50px;\n}\n\n.Authority {\n  text-align: center;\n  font-size: 1px;\n}\n\n.blue-text {\n  color: #6699cc;\n  font-weight: bold;\n}\n\n.file-container {\n  border: 1px solid #d3d3d3;\n  border-radius: 10px;\n  margin: 2% 0%;\n  background-color: #fff;\n  max-width: 100%;\n}\n\n#empDetails {\n  width: 350px;\n  height: 35px;\n}\n\n#query {\n  width: 250px;\n  height: 35px;\n}\n.shift{\n  margin-left: 10%;\n}\n.shift-left{\n  margin-right: -28%;\n}\n\n.input-group input[type=\"text\"] {\n  margin-right: 30px;\n}\n\n.title h3{\n  background-color: #6699cc;\n  color: #ffffff;\n  padding: 10px;\n  text-align: left;\n}\n\n.auth-codes {\n  text-align: center;\n}\n\n.doa-group {\n  margin-bottom: 20px;\n}\n\n.doa-type {\n  display: flex;\n  flex-direction: column;\n}\n\n.type-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.type-name {\n  flex: 1;\n  margin-bottom: 10px;\n}\n\n.type-dollar {\n  flex: 0 0 150px;\n  text-align: right;\n}\n\n.doa-dollar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dollar-text {\n  margin-left: auto;\n  margin-right: 11%; \n}\n\n.sub-cat-name {\n  margin-bottom: 10px;\n}\n\n.invalid {\n  border: 1px solid red;\n}\n\n.error-message {\n  color: red;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n.bordered-container {\n  border: 1px solid #d3d3d3; \n  padding: 20px;\n  max-width: 100%;\n  margin: 3% 0%;\n  border-radius: 1px;\n  padding-bottom: 1%;\n}\n.reduced-gap {\n  margin-left: -8%;\n}\n.reduced-gap-go {\n  margin-left: -13%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
